var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var SvgCertificatesHero = function SvgCertificatesHero(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1800 1459",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M494.733 500.358c0 14.113-11.433 25.55-25.537 25.55s-25.538-11.437-25.538-25.55c0-14.112 11.434-25.554 25.538-25.554 14.104 0 25.537 11.442 25.537 25.554Z",
    style: {
      fill: "url(#certificates-hero_svg__a)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.483 618.292c0 21.712-17.591 39.312-39.287 39.312-21.696 0-39.288-17.6-39.288-39.312 0-21.713 17.592-39.313 39.288-39.313 21.696 0 39.287 17.6 39.287 39.313Z",
    style: {
      fill: "url(#certificates-hero_svg__b)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.733 736.225c0 14.112-11.433 25.554-25.537 25.554s-25.538-11.442-25.538-25.554c0-14.113 11.434-25.55 25.538-25.55 14.104 0 25.537 11.437 25.537 25.55Z",
    style: {
      fill: "url(#certificates-hero_svg__c)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.658 854.163c0 16.283-13.191 29.483-29.462 29.483s-29.463-13.2-29.463-29.483c0-16.284 13.192-29.484 29.463-29.484s29.462 13.2 29.462 29.484Z",
    style: {
      fill: "url(#certificates-hero_svg__d)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.658 972.096c0 16.283-13.191 29.483-29.462 29.483s-29.463-13.2-29.463-29.483 13.192-29.483 29.463-29.483 29.462 13.2 29.462 29.483Z",
    style: {
      fill: "url(#certificates-hero_svg__e)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.658 1090.03c0 16.284-13.191 29.484-29.462 29.484s-29.463-13.2-29.463-29.484c0-16.283 13.192-29.483 29.463-29.483s29.462 13.2 29.462 29.483Z",
    style: {
      fill: "url(#certificates-hero_svg__f)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.017 1207.97c0 5.425-4.396 9.825-9.821 9.825s-9.821-4.4-9.821-9.825c0-5.43 4.396-9.83 9.821-9.83s9.821 4.4 9.821 9.83Z",
    style: {
      fill: "url(#certificates-hero_svg__g)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.017 1325.9c0 5.429-4.396 9.829-9.821 9.829s-9.821-4.4-9.821-9.829 4.396-9.829 9.821-9.829 9.821 4.4 9.821 9.829Z",
    style: {
      fill: "url(#certificates-hero_svg__h)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.517 500.358c0 16.284-13.192 29.484-29.463 29.484-16.275 0-29.467-13.2-29.467-29.484 0-16.283 13.192-29.483 29.467-29.483 16.271 0 29.463 13.2 29.463 29.483Z",
    style: {
      fill: "url(#certificates-hero_svg__i)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.517 618.292c0 16.283-13.192 29.483-29.463 29.483-16.275 0-29.467-13.2-29.467-29.483 0-16.284 13.192-29.484 29.467-29.484 16.271 0 29.463 13.2 29.463 29.484Z",
    style: {
      fill: "url(#certificates-hero_svg__j)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.588 736.225c0 14.112-11.434 25.554-25.534 25.554-14.104 0-25.537-11.442-25.537-25.554 0-14.113 11.433-25.55 25.537-25.55 14.1 0 25.534 11.437 25.534 25.55Z",
    style: {
      fill: "url(#certificates-hero_svg__k)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.733 854.163c0 9.77-7.916 17.687-17.679 17.687-9.767 0-17.679-7.917-17.679-17.688 0-9.77 7.912-17.691 17.679-17.691 9.763 0 17.679 7.921 17.679 17.692Z",
    style: {
      fill: "url(#certificates-hero_svg__l)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.733 972.096c0 9.771-7.916 17.692-17.679 17.692-9.767 0-17.679-7.921-17.679-17.692s7.912-17.692 17.679-17.692c9.763 0 17.679 7.921 17.679 17.692Z",
    style: {
      fill: "url(#certificates-hero_svg__m)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.875 1090.03c0 5.429-4.396 9.829-9.821 9.829s-9.821-4.4-9.821-9.829c0-5.425 4.396-9.825 9.821-9.825s9.821 4.4 9.821 9.825Z",
    style: {
      fill: "url(#certificates-hero_svg__n)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.875 1207.97c0 5.425-4.396 9.825-9.821 9.825s-9.821-4.4-9.821-9.825c0-5.43 4.396-9.83 9.821-9.83s9.821 4.4 9.821 9.83Z",
    style: {
      fill: "url(#certificates-hero_svg__o)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.875 1325.9c0 5.429-4.396 9.829-9.821 9.829s-9.821-4.4-9.821-9.829 4.396-9.829 9.821-9.829 9.821 4.4 9.821 9.829Z",
    style: {
      fill: "url(#certificates-hero_svg__p)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M744.196 500.358c0 21.709-17.588 39.309-39.288 39.309-21.695 0-39.283-17.6-39.283-39.309 0-21.712 17.588-39.312 39.283-39.312 21.7 0 39.288 17.6 39.288 39.312Z",
    style: {
      fill: "url(#certificates-hero_svg__q)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M714.733 618.292c0 5.429-4.4 9.829-9.825 9.829-5.42 0-9.82-4.4-9.82-9.829 0-5.43 4.4-9.829 9.82-9.829 5.425 0 9.825 4.399 9.825 9.829Z",
    style: {
      fill: "url(#certificates-hero_svg__r)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722.588 736.225c0 9.771-7.913 17.692-17.68 17.692-9.762 0-17.675-7.921-17.675-17.692 0-9.767 7.913-17.687 17.675-17.687 9.767 0 17.679 7.92 17.679 17.687Z",
    style: {
      fill: "url(#certificates-hero_svg__s)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722.588 854.163c0 9.77-7.913 17.687-17.68 17.687-9.762 0-17.675-7.917-17.675-17.688 0-9.77 7.913-17.691 17.675-17.691 9.767 0 17.679 7.921 17.679 17.692Z",
    style: {
      fill: "url(#certificates-hero_svg__t)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M730.446 972.096c0 14.112-11.433 25.554-25.538 25.554-14.1 0-25.533-11.442-25.533-25.554 0-14.113 11.433-25.554 25.533-25.554 14.105 0 25.538 11.441 25.538 25.554Z",
    style: {
      fill: "url(#certificates-hero_svg__u)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M714.733 1090.03c0 5.429-4.4 9.829-9.825 9.829-5.42 0-9.82-4.4-9.82-9.829 0-5.425 4.4-9.825 9.82-9.825 5.425 0 9.825 4.4 9.825 9.825Z",
    style: {
      fill: "url(#certificates-hero_svg__v)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M714.733 1207.97c0 5.425-4.4 9.825-9.825 9.825-5.42 0-9.82-4.4-9.82-9.825 0-5.43 4.4-9.83 9.82-9.83 5.425 0 9.825 4.4 9.825 9.83Z",
    style: {
      fill: "url(#certificates-hero_svg__w)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M714.733 1325.9c0 5.429-4.4 9.829-9.825 9.829-5.42 0-9.82-4.4-9.82-9.829s4.4-9.829 9.82-9.829c5.425 0 9.825 4.4 9.825 9.829Z",
    style: {
      fill: "url(#certificates-hero_svg__x)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M840.446 500.358c0 9.767-7.917 17.688-17.679 17.688-9.763 0-17.679-7.921-17.679-17.688 0-9.771 7.916-17.691 17.679-17.691 9.762 0 17.679 7.92 17.679 17.691Z",
    style: {
      fill: "url(#certificates-hero_svg__y)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.233 618.292c0 16.283-13.191 29.483-29.466 29.483-16.271 0-29.463-13.2-29.463-29.483 0-16.284 13.192-29.484 29.463-29.484 16.275 0 29.466 13.2 29.466 29.484Z",
    style: {
      fill: "url(#certificates-hero_svg__z)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M848.304 736.225c0 14.112-11.433 25.554-25.537 25.554s-25.534-11.442-25.534-25.554c0-14.113 11.43-25.55 25.534-25.55s25.537 11.437 25.537 25.55Z",
    style: {
      fill: "url(#certificates-hero_svg__A)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M832.588 854.163c0 5.424-4.396 9.825-9.821 9.825s-9.821-4.401-9.821-9.826c0-5.429 4.396-9.829 9.821-9.829s9.821 4.4 9.821 9.829Z",
    style: {
      fill: "url(#certificates-hero_svg__B)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M832.588 972.096c0 5.429-4.396 9.829-9.821 9.829s-9.821-4.4-9.821-9.829 4.396-9.829 9.821-9.829 9.821 4.4 9.821 9.829Z",
    style: {
      fill: "url(#certificates-hero_svg__C)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M840.446 1090.03c0 9.771-7.917 17.692-17.679 17.692-9.763 0-17.679-7.921-17.679-17.692 0-9.766 7.916-17.687 17.679-17.687 9.762 0 17.679 7.92 17.679 17.687Z",
    style: {
      fill: "url(#certificates-hero_svg__D)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M832.588 1207.97c0 5.425-4.396 9.825-9.821 9.825s-9.821-4.4-9.821-9.825c0-5.43 4.396-9.83 9.821-9.83s9.821 4.4 9.821 9.83Z",
    style: {
      fill: "url(#certificates-hero_svg__E)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M832.588 1325.9c0 5.429-4.396 9.829-9.821 9.829s-9.821-4.4-9.821-9.829 4.396-9.829 9.821-9.829 9.821 4.4 9.821 9.829Z",
    style: {
      fill: "url(#certificates-hero_svg__F)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M970.088 500.358c0 16.284-13.192 29.484-29.463 29.484-16.275 0-29.467-13.2-29.467-29.484 0-16.283 13.192-29.483 29.467-29.483 16.271 0 29.463 13.2 29.463 29.483Z",
    style: {
      fill: "url(#certificates-hero_svg__G)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M970.088 618.292c0 16.283-13.192 29.483-29.463 29.483-16.275 0-29.467-13.2-29.467-29.483 0-16.284 13.192-29.484 29.467-29.484 16.271 0 29.463 13.2 29.463 29.484Z",
    style: {
      fill: "url(#certificates-hero_svg__H)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M958.304 736.225c0 9.771-7.916 17.692-17.679 17.692-9.762 0-17.679-7.921-17.679-17.692 0-9.767 7.917-17.687 17.679-17.687 9.763 0 17.679 7.92 17.679 17.687Z",
    style: {
      fill: "url(#certificates-hero_svg__I)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M950.446 854.163c0 5.424-4.396 9.825-9.821 9.825s-9.821-4.401-9.821-9.826c0-5.429 4.396-9.829 9.821-9.829s9.821 4.4 9.821 9.829Z",
    style: {
      fill: "url(#certificates-hero_svg__J)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M958.304 972.096c0 9.771-7.916 17.692-17.679 17.692-9.762 0-17.679-7.921-17.679-17.692s7.917-17.692 17.679-17.692c9.763 0 17.679 7.921 17.679 17.692Z",
    style: {
      fill: "url(#certificates-hero_svg__K)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M958.304 1090.03c0 9.771-7.916 17.692-17.679 17.692-9.762 0-17.679-7.921-17.679-17.692 0-9.766 7.917-17.687 17.679-17.687 9.763 0 17.679 7.92 17.679 17.687Z",
    style: {
      fill: "url(#certificates-hero_svg__L)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M950.446 1207.97c0 5.425-4.396 9.825-9.821 9.825s-9.821-4.4-9.821-9.825c0-5.43 4.396-9.83 9.821-9.83s9.821 4.4 9.821 9.83Z",
    style: {
      fill: "url(#certificates-hero_svg__M)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M966.158 1325.9c0 14.112-11.429 25.554-25.533 25.554-14.104 0-25.537-11.442-25.537-25.554 0-14.112 11.433-25.554 25.537-25.554s25.533 11.442 25.533 25.554Z",
    style: {
      fill: "url(#certificates-hero_svg__N)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1084.02 500.358c0 14.113-11.434 25.55-25.534 25.55-14.104 0-25.537-11.437-25.537-25.55 0-14.112 11.433-25.554 25.537-25.554 14.1 0 25.534 11.442 25.534 25.554Z",
    style: {
      fill: "url(#certificates-hero_svg__O)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1068.3 618.292c0 5.429-4.4 9.829-9.821 9.829-5.425 0-9.825-4.4-9.825-9.829 0-5.43 4.4-9.829 9.825-9.829 5.421 0 9.821 4.399 9.821 9.829Z",
    style: {
      fill: "url(#certificates-hero_svg__P)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1068.3 736.225c0 5.429-4.4 9.829-9.821 9.829-5.425 0-9.825-4.4-9.825-9.829 0-5.425 4.4-9.825 9.825-9.825 5.421 0 9.821 4.4 9.821 9.825Z",
    style: {
      fill: "url(#certificates-hero_svg__Q)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1076.16 854.163c0 9.77-7.912 17.687-17.675 17.687-9.766 0-17.679-7.917-17.679-17.688 0-9.77 7.913-17.691 17.679-17.691 9.763 0 17.675 7.921 17.675 17.692Z",
    style: {
      fill: "url(#certificates-hero_svg__R)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1068.3 972.096c0 5.429-4.4 9.829-9.821 9.829-5.425 0-9.825-4.4-9.825-9.829s4.4-9.829 9.825-9.829c5.421 0 9.821 4.4 9.821 9.829Z",
    style: {
      fill: "url(#certificates-hero_svg__S)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1084.02 1090.03c0 14.113-11.434 25.554-25.534 25.554-14.104 0-25.537-11.441-25.537-25.554 0-14.112 11.433-25.55 25.537-25.55 14.1 0 25.534 11.438 25.534 25.55Z",
    style: {
      fill: "url(#certificates-hero_svg__T)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1068.3 1207.97c0 5.425-4.4 9.825-9.821 9.825-5.425 0-9.825-4.4-9.825-9.825 0-5.43 4.4-9.83 9.825-9.83 5.421 0 9.821 4.4 9.821 9.83Z",
    style: {
      fill: "url(#certificates-hero_svg__U)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1068.3 1325.9c0 5.429-4.4 9.829-9.821 9.829-5.425 0-9.825-4.4-9.825-9.829s4.4-9.829 9.825-9.829c5.421 0 9.821 4.4 9.821 9.829Z",
    style: {
      fill: "url(#certificates-hero_svg__V)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1194.02 500.358c0 9.767-7.913 17.688-17.679 17.688-9.763 0-17.68-7.921-17.68-17.688 0-9.771 7.917-17.691 17.68-17.691 9.766 0 17.679 7.92 17.679 17.691Z",
    style: {
      fill: "url(#certificates-hero_svg__W)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1186.16 618.292c0 5.429-4.396 9.829-9.821 9.829-5.42 0-9.82-4.4-9.82-9.829 0-5.43 4.4-9.829 9.82-9.829 5.425 0 9.821 4.399 9.821 9.829Z",
    style: {
      fill: "url(#certificates-hero_svg__X)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1186.16 736.225c0 5.429-4.396 9.829-9.821 9.829-5.42 0-9.82-4.4-9.82-9.829 0-5.425 4.4-9.825 9.82-9.825 5.425 0 9.821 4.4 9.821 9.825Z",
    style: {
      fill: "url(#certificates-hero_svg__Y)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1186.16 854.163c0 5.424-4.396 9.825-9.821 9.825-5.42 0-9.82-4.401-9.82-9.826 0-5.429 4.4-9.829 9.82-9.829 5.425 0 9.821 4.4 9.821 9.829Z",
    style: {
      fill: "url(#certificates-hero_svg__Z)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1186.16 972.096c0 5.429-4.396 9.829-9.821 9.829-5.42 0-9.82-4.4-9.82-9.829s4.4-9.829 9.82-9.829c5.425 0 9.821 4.4 9.821 9.829Z",
    style: {
      fill: "url(#certificates-hero_svg__aa)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1186.16 1090.03c0 5.429-4.396 9.829-9.821 9.829-5.42 0-9.82-4.4-9.82-9.829 0-5.425 4.4-9.825 9.82-9.825 5.425 0 9.821 4.4 9.821 9.825Z",
    style: {
      fill: "url(#certificates-hero_svg__ab)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1186.16 1207.97c0 5.425-4.396 9.825-9.821 9.825-5.42 0-9.82-4.4-9.82-9.825 0-5.43 4.4-9.83 9.82-9.83 5.425 0 9.821 4.4 9.821 9.83Z",
    style: {
      fill: "url(#certificates-hero_svg__ac)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1186.16 1325.9c0 5.429-4.396 9.829-9.821 9.829-5.42 0-9.82-4.4-9.82-9.829s4.4-9.829 9.82-9.829c5.425 0 9.821 4.4 9.821 9.829Z",
    style: {
      fill: "url(#certificates-hero_svg__ad)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1304.02 500.358c0 5.425-4.396 9.825-9.821 9.825s-9.821-4.4-9.821-9.825c0-5.429 4.396-9.829 9.821-9.829s9.821 4.4 9.821 9.829Z",
    style: {
      fill: "url(#certificates-hero_svg__ae)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1304.02 618.292c0 5.429-4.396 9.829-9.821 9.829s-9.821-4.4-9.821-9.829c0-5.43 4.396-9.829 9.821-9.829s9.821 4.399 9.821 9.829Z",
    style: {
      fill: "url(#certificates-hero_svg__af)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1304.02 736.225c0 5.429-4.396 9.829-9.821 9.829s-9.821-4.4-9.821-9.829c0-5.425 4.396-9.825 9.821-9.825s9.821 4.4 9.821 9.825Z",
    style: {
      fill: "url(#certificates-hero_svg__ag)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1304.02 854.163c0 5.424-4.396 9.825-9.821 9.825s-9.821-4.401-9.821-9.826c0-5.429 4.396-9.829 9.821-9.829s9.821 4.4 9.821 9.829Z",
    style: {
      fill: "url(#certificates-hero_svg__ah)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1311.88 972.096c0 9.771-7.917 17.692-17.679 17.692-9.763 0-17.679-7.921-17.679-17.692s7.916-17.692 17.679-17.692c9.762 0 17.679 7.921 17.679 17.692Z",
    style: {
      fill: "url(#certificates-hero_svg__ai)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1304.02 1090.03c0 5.429-4.396 9.829-9.821 9.829s-9.821-4.4-9.821-9.829c0-5.425 4.396-9.825 9.821-9.825s9.821 4.4 9.821 9.825Z",
    style: {
      fill: "url(#certificates-hero_svg__aj)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1304.02 1207.97c0 5.425-4.396 9.825-9.821 9.825s-9.821-4.4-9.821-9.825c0-5.43 4.396-9.83 9.821-9.83s9.821 4.4 9.821 9.83Z",
    style: {
      fill: "url(#certificates-hero_svg__ak)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1319.73 1325.9c0 14.112-11.433 25.554-25.537 25.554s-25.538-11.442-25.538-25.554c0-14.112 11.434-25.554 25.538-25.554 14.104 0 25.537 11.442 25.537 25.554Z",
    style: {
      fill: "url(#certificates-hero_svg__al)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1421.88 500.358c0 5.425-4.396 9.825-9.821 9.825s-9.821-4.4-9.821-9.825c0-5.429 4.396-9.829 9.821-9.829s9.821 4.4 9.821 9.829Z",
    style: {
      fill: "url(#certificates-hero_svg__am)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1429.73 618.292c0 9.771-7.916 17.691-17.679 17.691-9.766 0-17.679-7.92-17.679-17.691 0-9.771 7.913-17.692 17.679-17.692 9.763 0 17.679 7.921 17.679 17.692Z",
    style: {
      fill: "url(#certificates-hero_svg__an)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1421.88 736.225c0 5.429-4.396 9.829-9.821 9.829s-9.821-4.4-9.821-9.829c0-5.425 4.396-9.825 9.821-9.825s9.821 4.4 9.821 9.825Z",
    style: {
      fill: "url(#certificates-hero_svg__ao)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1421.88 854.163c0 5.424-4.396 9.825-9.821 9.825s-9.821-4.401-9.821-9.826c0-5.429 4.396-9.829 9.821-9.829s9.821 4.4 9.821 9.829Z",
    style: {
      fill: "url(#certificates-hero_svg__ap)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1421.88 972.096c0 5.429-4.396 9.829-9.821 9.829s-9.821-4.4-9.821-9.829 4.396-9.829 9.821-9.829 9.821 4.4 9.821 9.829Z",
    style: {
      fill: "url(#certificates-hero_svg__aq)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1421.88 1090.03c0 5.429-4.396 9.829-9.821 9.829s-9.821-4.4-9.821-9.829c0-5.425 4.396-9.825 9.821-9.825s9.821 4.4 9.821 9.825Z",
    style: {
      fill: "url(#certificates-hero_svg__ar)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1437.59 1207.97c0 14.112-11.434 25.55-25.534 25.55-14.104 0-25.537-11.438-25.537-25.55 0-14.113 11.433-25.554 25.537-25.554 14.1 0 25.534 11.441 25.534 25.554Z",
    style: {
      fill: "url(#certificates-hero_svg__as)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1429.73 1325.9c0 9.771-7.916 17.692-17.679 17.692-9.766 0-17.679-7.921-17.679-17.692s7.913-17.692 17.679-17.692c9.763 0 17.679 7.921 17.679 17.692Z",
    style: {
      fill: "url(#certificates-hero_svg__at)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1539.73 500.358c0 5.425-4.4 9.825-9.825 9.825-5.42 0-9.82-4.4-9.82-9.825 0-5.429 4.4-9.829 9.82-9.829 5.425 0 9.825 4.4 9.825 9.829Z",
    style: {
      fill: "url(#certificates-hero_svg__au)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1539.73 618.292c0 5.429-4.4 9.829-9.825 9.829-5.42 0-9.82-4.4-9.82-9.829 0-5.43 4.4-9.829 9.82-9.829 5.425 0 9.825 4.399 9.825 9.829Z",
    style: {
      fill: "url(#certificates-hero_svg__av)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1539.73 736.225c0 5.429-4.4 9.829-9.825 9.829-5.42 0-9.82-4.4-9.82-9.829 0-5.425 4.4-9.825 9.82-9.825 5.425 0 9.825 4.4 9.825 9.825Z",
    style: {
      fill: "url(#certificates-hero_svg__aw)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1547.59 854.163c0 9.77-7.913 17.687-17.68 17.687-9.762 0-17.675-7.917-17.675-17.688 0-9.77 7.913-17.691 17.675-17.691 9.767 0 17.68 7.921 17.68 17.692Z",
    style: {
      fill: "url(#certificates-hero_svg__ax)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1539.73 972.096c0 5.429-4.4 9.829-9.825 9.829-5.42 0-9.82-4.4-9.82-9.829s4.4-9.829 9.82-9.829c5.425 0 9.825 4.4 9.825 9.829Z",
    style: {
      fill: "url(#certificates-hero_svg__ay)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1539.73 1090.03c0 5.429-4.4 9.829-9.825 9.829-5.42 0-9.82-4.4-9.82-9.829 0-5.425 4.4-9.825 9.82-9.825 5.425 0 9.825 4.4 9.825 9.825Z",
    style: {
      fill: "url(#certificates-hero_svg__az)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1539.73 1207.97c0 5.425-4.4 9.825-9.825 9.825-5.42 0-9.82-4.4-9.82-9.825 0-5.43 4.4-9.83 9.82-9.83 5.425 0 9.825 4.4 9.825 9.83Z",
    style: {
      fill: "url(#certificates-hero_svg__aA)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1555.45 1325.9c0 14.112-11.434 25.554-25.538 25.554-14.1 0-25.533-11.442-25.533-25.554 0-14.112 11.433-25.554 25.533-25.554 14.104 0 25.538 11.442 25.538 25.554Z",
    style: {
      fill: "url(#certificates-hero_svg__aB)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1657.59 500.358c0 5.425-4.396 9.825-9.821 9.825s-9.821-4.4-9.821-9.825c0-5.429 4.396-9.829 9.821-9.829s9.821 4.4 9.821 9.829Z",
    style: {
      fill: "url(#certificates-hero_svg__aC)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1657.59 618.292c0 5.429-4.396 9.829-9.821 9.829s-9.821-4.4-9.821-9.829c0-5.43 4.396-9.829 9.821-9.829s9.821 4.399 9.821 9.829Z",
    style: {
      fill: "url(#certificates-hero_svg__aD)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1657.59 736.225c0 5.429-4.396 9.829-9.821 9.829s-9.821-4.4-9.821-9.829c0-5.425 4.396-9.825 9.821-9.825s9.821 4.4 9.821 9.825Z",
    style: {
      fill: "url(#certificates-hero_svg__aE)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1657.59 854.163c0 5.424-4.396 9.825-9.821 9.825s-9.821-4.401-9.821-9.826c0-5.429 4.396-9.829 9.821-9.829s9.821 4.4 9.821 9.829Z",
    style: {
      fill: "url(#certificates-hero_svg__aF)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1673.3 972.096c0 14.112-11.433 25.554-25.537 25.554s-25.534-11.442-25.534-25.554c0-14.113 11.43-25.554 25.534-25.554s25.537 11.441 25.537 25.554Z",
    style: {
      fill: "url(#certificates-hero_svg__aG)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1657.59 1090.03c0 5.429-4.396 9.829-9.821 9.829s-9.821-4.4-9.821-9.829c0-5.425 4.396-9.825 9.821-9.825s9.821 4.4 9.821 9.825Z",
    style: {
      fill: "url(#certificates-hero_svg__aH)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1673.3 1207.97c0 14.112-11.433 25.55-25.537 25.55s-25.534-11.438-25.534-25.55c0-14.113 11.43-25.554 25.534-25.554s25.537 11.441 25.537 25.554Z",
    style: {
      fill: "url(#certificates-hero_svg__aI)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1657.59 1325.9c0 5.429-4.396 9.829-9.821 9.829s-9.821-4.4-9.821-9.829 4.396-9.829 9.821-9.829 9.821 4.4 9.821 9.829Z",
    style: {
      fill: "url(#certificates-hero_svg__aJ)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1775.45 500.358c0 5.425-4.396 9.825-9.821 9.825s-9.821-4.4-9.821-9.825c0-5.429 4.396-9.829 9.821-9.829s9.821 4.4 9.821 9.829Z",
    style: {
      fill: "url(#certificates-hero_svg__aK)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1775.45 618.292c0 5.429-4.396 9.829-9.821 9.829s-9.821-4.4-9.821-9.829c0-5.43 4.396-9.829 9.821-9.829s9.821 4.399 9.821 9.829Z",
    style: {
      fill: "url(#certificates-hero_svg__aL)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1775.45 736.225c0 5.429-4.396 9.829-9.821 9.829s-9.821-4.4-9.821-9.829c0-5.425 4.396-9.825 9.821-9.825s9.821 4.4 9.821 9.825Z",
    style: {
      fill: "url(#certificates-hero_svg__aM)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1791.16 854.163c0 14.112-11.429 25.55-25.533 25.55-14.104 0-25.538-11.438-25.538-25.55 0-14.113 11.434-25.555 25.538-25.555 14.104 0 25.533 11.442 25.533 25.554Z",
    style: {
      fill: "url(#certificates-hero_svg__aN)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1783.3 972.096c0 9.771-7.916 17.692-17.679 17.692-9.763 0-17.679-7.921-17.679-17.692s7.917-17.692 17.679-17.692c9.763 0 17.679 7.921 17.679 17.692Z",
    style: {
      fill: "url(#certificates-hero_svg__aO)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1795.09 1090.03c0 16.284-13.192 29.484-29.463 29.484-16.275 0-29.467-13.2-29.467-29.484 0-16.283 13.192-29.483 29.467-29.483 16.271 0 29.463 13.2 29.463 29.483Z",
    style: {
      fill: "url(#certificates-hero_svg__aP)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1791.16 1207.97c0 14.112-11.429 25.55-25.533 25.55-14.104 0-25.538-11.438-25.538-25.55 0-14.113 11.434-25.554 25.538-25.554 14.104 0 25.533 11.441 25.533 25.554Z",
    style: {
      fill: "url(#certificates-hero_svg__aQ)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1791.16 1325.9c0 14.112-11.429 25.554-25.533 25.554-14.104 0-25.538-11.442-25.538-25.554 0-14.112 11.434-25.554 25.538-25.554 14.104 0 25.533 11.442 25.533 25.554Z",
    style: {
      fill: "url(#certificates-hero_svg__aR)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 729.167C0 327.104 327.104 0 729.167 0c402.062 0 729.166 327.104 729.166 729.167 0 402.062-327.104 729.166-729.166 729.166C327.104 1458.333 0 1131.229 0 729.167Zm721.292 494.52v146.125c2.916 0 5.395.292 7.875.292h.145c353.501 0 640.938-287.437 640.938-640.937S1082.812 88.229 729.312 88.229c-2.916 0-5.395.292-7.874.292v225.75l-.584.291-425.542 79.771s64.167 460.25 68.542 479.646c10.646 46.667 33.396 90.125 66.646 125.563 85.75 91.145 182.875 165.083 290.208 223.271v1.02c.584 0 .584-.291.584-.291V314.417l.875.291 425.25 79.771s-63.875 460.25-68.542 479.646c-10.354 46.667-33.104 90.125-66.646 125.562-85.75 91.146-182.583 165.084-289.917 223.271h-.145v1.021c-.292 0-.875-.292-.875-.292Z",
    style: {
      fill: "#e8712e"
    }
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "certificates-hero_svg__a",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.976 1128.55 401.457) scale(1643.411)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "certificates-hero_svg__b",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.976 1128.55 401.457) scale(1643.411)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "certificates-hero_svg__c",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.976 1128.55 401.457) scale(1643.411)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "certificates-hero_svg__d",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.976 1128.55 401.457) scale(1643.411)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "certificates-hero_svg__e",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.976 1128.55 401.457) scale(1643.411)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "certificates-hero_svg__f",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.976 1128.55 401.457) scale(1643.411)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "certificates-hero_svg__g",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.976 1128.55 401.457) scale(1643.411)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "certificates-hero_svg__h",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.976 1128.55 401.457) scale(1643.411)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "certificates-hero_svg__i",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.976 1128.55 401.457) scale(1643.411)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "certificates-hero_svg__j",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.976 1128.55 401.457) scale(1643.411)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "certificates-hero_svg__k",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.976 1128.55 401.457) scale(1643.411)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "certificates-hero_svg__l",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.976 1128.55 401.457) scale(1643.411)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "certificates-hero_svg__m",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.976 1128.55 401.457) scale(1643.411)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "certificates-hero_svg__n",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.976 1128.55 401.457) scale(1643.411)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "certificates-hero_svg__o",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.976 1128.55 401.457) scale(1643.411)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "certificates-hero_svg__p",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.976 1128.55 401.457) scale(1643.411)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "certificates-hero_svg__q",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.976 1128.55 401.457) scale(1643.411)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "certificates-hero_svg__r",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.976 1128.55 401.457) scale(1643.411)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "certificates-hero_svg__s",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.976 1128.55 401.457) scale(1643.411)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "certificates-hero_svg__t",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.976 1128.55 401.457) scale(1643.411)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "certificates-hero_svg__u",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.976 1128.55 401.457) scale(1643.411)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "certificates-hero_svg__v",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.976 1128.55 401.457) scale(1643.411)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "certificates-hero_svg__w",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.976 1128.55 401.457) scale(1643.411)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "certificates-hero_svg__x",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.976 1128.55 401.457) scale(1643.411)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "certificates-hero_svg__y",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.976 1128.55 401.457) scale(1643.411)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "certificates-hero_svg__z",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.976 1128.55 401.457) scale(1643.411)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "certificates-hero_svg__A",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.976 1128.55 401.457) scale(1643.411)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "certificates-hero_svg__B",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.976 1128.55 401.457) scale(1643.411)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "certificates-hero_svg__C",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.976 1128.55 401.457) scale(1643.411)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "certificates-hero_svg__D",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.976 1128.55 401.457) scale(1643.411)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "certificates-hero_svg__E",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.976 1128.55 401.457) scale(1643.411)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "certificates-hero_svg__F",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.976 1128.55 401.457) scale(1643.411)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "certificates-hero_svg__G",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.976 1128.55 401.457) scale(1643.411)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "certificates-hero_svg__H",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.976 1128.55 401.457) scale(1643.411)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "certificates-hero_svg__I",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.976 1128.55 401.457) scale(1643.411)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "certificates-hero_svg__J",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.976 1128.55 401.457) scale(1643.411)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "certificates-hero_svg__K",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.976 1128.55 401.457) scale(1643.411)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "certificates-hero_svg__L",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.976 1128.55 401.457) scale(1643.411)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "certificates-hero_svg__M",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.976 1128.55 401.457) scale(1643.411)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "certificates-hero_svg__N",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.976 1128.55 401.457) scale(1643.411)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "certificates-hero_svg__O",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.976 1128.55 401.457) scale(1643.411)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "certificates-hero_svg__P",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.976 1128.55 401.457) scale(1643.411)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "certificates-hero_svg__Q",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.976 1128.55 401.457) scale(1643.411)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "certificates-hero_svg__R",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.976 1128.55 401.457) scale(1643.411)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "certificates-hero_svg__S",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.976 1128.55 401.457) scale(1643.411)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "certificates-hero_svg__T",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.976 1128.55 401.457) scale(1643.411)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "certificates-hero_svg__U",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.976 1128.55 401.457) scale(1643.411)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "certificates-hero_svg__V",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.976 1128.55 401.457) scale(1643.411)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "certificates-hero_svg__W",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.976 1128.55 401.457) scale(1643.411)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "certificates-hero_svg__X",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.976 1128.55 401.457) scale(1643.411)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "certificates-hero_svg__Y",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.976 1128.55 401.457) scale(1643.411)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "certificates-hero_svg__Z",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.976 1128.55 401.457) scale(1643.411)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "certificates-hero_svg__aa",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.976 1128.55 401.457) scale(1643.411)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "certificates-hero_svg__ab",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.976 1128.55 401.457) scale(1643.411)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "certificates-hero_svg__ac",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.976 1128.55 401.457) scale(1643.411)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "certificates-hero_svg__ad",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.976 1128.55 401.457) scale(1643.411)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "certificates-hero_svg__ae",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.976 1128.55 401.457) scale(1643.411)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "certificates-hero_svg__af",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.976 1128.55 401.457) scale(1643.411)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "certificates-hero_svg__ag",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.976 1128.55 401.457) scale(1643.411)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "certificates-hero_svg__ah",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.976 1128.55 401.457) scale(1643.411)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "certificates-hero_svg__ai",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.976 1128.55 401.457) scale(1643.411)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "certificates-hero_svg__aj",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.976 1128.55 401.457) scale(1643.411)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "certificates-hero_svg__ak",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.976 1128.55 401.457) scale(1643.411)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "certificates-hero_svg__al",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.976 1128.55 401.457) scale(1643.411)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "certificates-hero_svg__am",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.976 1128.55 401.457) scale(1643.411)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "certificates-hero_svg__an",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.976 1128.55 401.457) scale(1643.411)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "certificates-hero_svg__ao",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.976 1128.55 401.457) scale(1643.411)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "certificates-hero_svg__ap",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.976 1128.55 401.457) scale(1643.411)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "certificates-hero_svg__aq",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.976 1128.55 401.457) scale(1643.411)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "certificates-hero_svg__ar",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.976 1128.55 401.457) scale(1643.411)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "certificates-hero_svg__as",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.976 1128.55 401.457) scale(1643.411)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "certificates-hero_svg__at",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.976 1128.55 401.457) scale(1643.411)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "certificates-hero_svg__au",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.976 1128.55 401.457) scale(1643.411)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "certificates-hero_svg__av",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.976 1128.55 401.457) scale(1643.411)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "certificates-hero_svg__aw",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.976 1128.55 401.457) scale(1643.411)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "certificates-hero_svg__ax",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.976 1128.55 401.457) scale(1643.411)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "certificates-hero_svg__ay",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.976 1128.55 401.457) scale(1643.411)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "certificates-hero_svg__az",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.976 1128.55 401.457) scale(1643.411)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "certificates-hero_svg__aA",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.976 1128.55 401.457) scale(1643.411)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "certificates-hero_svg__aB",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.976 1128.55 401.457) scale(1643.411)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "certificates-hero_svg__aC",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.976 1128.55 401.457) scale(1643.411)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "certificates-hero_svg__aD",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.976 1128.55 401.457) scale(1643.411)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "certificates-hero_svg__aE",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.976 1128.55 401.457) scale(1643.411)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "certificates-hero_svg__aF",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.976 1128.55 401.457) scale(1643.411)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "certificates-hero_svg__aG",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.976 1128.55 401.457) scale(1643.411)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "certificates-hero_svg__aH",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.976 1128.55 401.457) scale(1643.411)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "certificates-hero_svg__aI",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.976 1128.55 401.457) scale(1643.411)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "certificates-hero_svg__aJ",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.976 1128.55 401.457) scale(1643.411)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "certificates-hero_svg__aK",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.976 1128.55 401.457) scale(1643.411)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "certificates-hero_svg__aL",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.976 1128.55 401.457) scale(1643.411)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "certificates-hero_svg__aM",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.976 1128.55 401.457) scale(1643.411)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "certificates-hero_svg__aN",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.976 1128.55 401.457) scale(1643.411)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "certificates-hero_svg__aO",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.976 1128.55 401.457) scale(1643.411)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "certificates-hero_svg__aP",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.976 1128.55 401.457) scale(1643.411)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "certificates-hero_svg__aQ",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.976 1128.55 401.457) scale(1643.411)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "certificates-hero_svg__aR",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-145.976 1128.55 401.457) scale(1643.411)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  }))));
};
export default SvgCertificatesHero;